import Repository from "./Repository";

export default {
    getSurveysList(params) {
        return Repository.get(`/survey/list?page=${params.current+1}&size=${params.size}`);
    },
    getMytargetCampaigns() {
        return Repository.get("/customer/mytarget/campaigns");
    },
    getUpdatedSurveysList(params) {
        return Repository.get(`/survey/list?page=1&size=${params.current*params.size}`);
    },
};
